import React, {useState} from 'react';
import {IModule} from "../../../../../models/IModule";
import {EnumLanguage} from "../../../../../enums/EnumLanguage";
import {DeleteOutlined, EditOutlined, MenuOutlined} from "@ant-design/icons";
import styles from './AdministrationModuleRow.module.css'
import clsx from "clsx";
import {EnumFog} from "../../../../../components/Utils/FogContainer/FogContainer";
import ModalPortal from "../../../../../Portals/ModalPortal";
import EditModule from "../../EditModule/EditModule";
import Popover from "../../../../../components/Utils/Popover/Popover";
import Confirm from "../../../../../components/Utils/Popover/Confirm/Confirm";
import {useAppDispatch} from "../../../../../hooks/redux";
import {deleteModuleThunk} from "../../../../../store/actions/ModulesActions";


interface IProps {
    moduleData: IModule
}

const AdministrationModuleRow = ({moduleData}: IProps) => {

    const {title} = moduleData
    const dispatch = useAppDispatch()


    const [isOpenEditModule, setIsOpenEditModule] = useState<boolean>(false)

    const [isOpenDeleteModuleConfirm, setIsOpenDeleteModuleConfirm] = useState<boolean>(false)


    const [isLoadingDeleteModule, setIsLoadingDeleteModule] = useState<boolean>(false)
    const deleteModule = (id: number) => {
        setIsLoadingDeleteModule(true)
        dispatch(deleteModuleThunk(id)).then(() => {
            setIsLoadingDeleteModule(false)
        })

    }

    const openEditModule = (event: React.MouseEvent) => {
        setIsOpenEditModule(true)
    }

    return (
        <div className={styles.wrapper}>
            <div className={clsx(styles.iconWrapper, styles.iconGrab)}>
                <MenuOutlined/>
            </div>
            <div className={styles.title} onDoubleClick={openEditModule}>
                {title[EnumLanguage.ru]}
            </div>
            <div className={styles.iconWrapper} onClick={() => setIsOpenEditModule(true)}>
                <EditOutlined/>
            </div>
            <div className={styles.iconWrapper}>
                <DeleteOutlined onClick={() => setIsOpenDeleteModuleConfirm(prev => !prev)}/>
                <Popover isOpen={isOpenDeleteModuleConfirm} setIsOpen={setIsOpenDeleteModuleConfirm}>
                    <Confirm
                        loading={isLoadingDeleteModule}
                        text={'Точно удалить?'}
                        callback={() => deleteModule(moduleData.id)}
                        callbackCancel={() => setIsOpenDeleteModuleConfirm(false)}
                    />
                </Popover>
            </div>
            <ModalPortal options={{
                setStateModal: setIsOpenEditModule,
                fogPower: EnumFog.strong,
                statusModal: isOpenEditModule
            }}>
                <EditModule setIsOpenEditModule={setIsOpenEditModule} type={moduleData.type} module={moduleData}/>
            </ModalPortal>
        </div>
    );
};

export default AdministrationModuleRow;